import { Component, inject, input } from '@angular/core';
import { RadioButtonGroupComponent } from '../radio-button-group/radio-button-group.component';
import { IconComponent } from '../../../atoms/icon/icon.component';

@Component({
  selector: 'app-radio-button-icon',
  templateUrl: './radio-button-icon.component.html',
  styleUrls: ['./radio-button-icon.component.scss'],
  imports: [IconComponent],
})
export class RadioButtonIconComponent {
  radioButtonGroup = inject(RadioButtonGroupComponent);

  readonly icon = input('');
}
